export default __webpack_public_path__ + "static/media/pq.5ddb1fd0.jpg";